import { api, type ApiType } from 'lib/api';
import { stringParse } from 'utils';

export const apiSuppliers: ApiType = {
  get: {
    list: () => api.get('/api/suppliers?isActive=true'),
    listSupplierPortalEnabled: ({ vars }) =>
      api.get(
        stringParse('/api/suppliers?isActive=true&supplierPortalEnabled=true&search={0}', vars)
      ),
    facilityProcesstype: () => api.get('/api/facilityprocesstype'),
    facilitiesList: ({ vars, query }) =>
      api.get(stringParse('/api/organizations/{0}/sub-suppliers/{1}/facilities', vars), query),
    globalSubSupplierList: ({ vars }) =>
      api.get(stringParse('/api/meta/search/global-sub-suppliers?search={0}', vars)),
    mergeRequest: ({ vars }) => api.get(stringParse('/api/suppliers/{0}/mergerequests/{1}', vars)),
  },
  post: {
    create: ({ vars, data }) =>
      api.post(stringParse('/api/organizations/{0}/organizationsubsuppliers', vars), data),
    createFacilities: ({ vars, data }) => {
      return api.post(
        stringParse('/api/organizations/{0}/sub-suppliers/{1}/facilities', vars),
        data
      );
    },
    signup: ({ data }) => api.post('/api/supplierportalaccount', data),
    mergeRequestAction: ({ vars, data }) =>
      api.post(stringParse('/api/suppliers/{0}/mergerequests/{1}', vars), data),
  },
  put: {
    byId: ({ data, vars }) =>
      api.put(stringParse('/api/organizations/{0}/sub-suppliers/{1}/facility/{2}', vars), data),
    bulkUpdate: ({ data, vars }) =>
      api.put(stringParse('/api/organizations/{0}/sub-suppliers/{1}/facility', vars), data),
    bulkDeleteFacilities: ({ vars, data }) =>
      api.put(stringParse('/api/organizations/{0}/sub-suppliers/{1}/facilities', vars), data),
  },
  delete: {
    byFacilityId: ({ vars }) =>
      api.delete(stringParse('/api/organizations/{0}/sub-suppliers/{1}/facilities/{2}', vars)),
  },
};
